import { PortModel } from '../models/port.model';

export const portNameTemplate = (port: PortModel): string => {
  return port.terminal
    ? `${port.fullName} - ${port.terminal} (${port.country})`
    : `${port.fullName} (${port.country})`;
};
